/**
 * Submit a form to HubSpot's public Forms API v3 (no auth required).
 * Docs: https://developers.hubspot.com/docs/api/marketing/forms
 */
const HS_PORTAL_ID = "247019970";

export async function submitToHubSpot({ formId, fields, pageName }) {
  const url = `https://api.hsforms.com/submissions/v3/integration/submit/${HS_PORTAL_ID}/${formId}`;
  const body = {
    fields: fields
      .filter((f) => f.value !== undefined && f.value !== null && f.value !== "")
      .map((f) => ({ objectTypeId: "0-1", name: f.name, value: f.value })),
    context: {
      pageUri: typeof window !== "undefined" ? window.location.href : "",
      pageName: pageName || "Site",
    },
  };

  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    let detail = "";
    try {
      const j = await res.json();
      detail = j?.message || JSON.stringify(j);
    } catch (_) {
      // ignore
    }
    throw new Error(`HubSpot submission failed (${res.status}): ${detail}`);
  }
  return res.json();
}

export const HS_FORM_INQUIRY = "e727e3ec-6198-48b6-b789-5dec8af50c5c";
export const HS_FORM_CHAPTER = "55ffdaa7-11ea-4a47-bd90-a2510755a049";
